import apiClient from '~/plugins/apiClient/client';
import appConfig from '~/plugins/config';
import { finishLogout } from '~/services/auth/utils';

// > Singleton instance
const apiClientInstance = apiClient('/', { notifyOnError: true, onAuthErrorFn: () => finishLogout(true) });
export const mockApiClientInstance = apiClient('/', {
    notifyOnError: true,
    axios: appConfig.mockApi,
    onAuthErrorFn: () => finishLogout(true),
});

export default apiClientInstance;
